import { Button, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CalendarMonth } from "@mui/icons-material";

export type FleetEventChildPart = "all" | "calendar";

type Props = {
  isEditable: boolean;
  openAllFleetEvents: () => void;
  /** Which part to render: all (default), only calendar button */
  part?: FleetEventChildPart;
};

export function FleetEventChildPartial({
  isEditable,
  openAllFleetEvents,
  part = "all"
}: Readonly<Props>) {
  const { t } = useTranslation();

  const showCalendar = part === "all" || part === "calendar";

  if (!showCalendar || !isEditable) return null;

  return (
    <Tooltip title={<Typography>{t("Show All Events")}</Typography>}>
      <Button
        sx={{ height: "40px", whiteSpace: "nowrap", minWidth: 30 }}
        data-testid="show-all-fleet-events-btn"
        onClick={openAllFleetEvents}
        color="secondary"
      >
        <CalendarMonth />
      </Button>
    </Tooltip>
  );
}
